import axios from 'axios';
import { Component, useState, useEffect } from 'react';
import { isMobile } from 'react-device-detect';
import {
  YMaps,
  Map,
  Placemark,
  ZoomControl,
  GeolocationControl,
  FullscreenControl,
  withYMaps
} from 'react-yandex-maps';
import Skelet from '../Skelet';
import styles from '../../styles/modules/contacts/ContactsMap.module.scss';

class TemplateProvider extends Component {
  constructor() {
    super();
    this.state = { template: null };
  }

  componentDidMount() {
    const { ymaps } = this.props;

    this.setState({
      template: ymaps.templateLayoutFactory.createClass(
        `<div class="point single">
          <svg xmlns="http://www.w3.org/2000/svg" width="60" height="68" viewBox="0 0 60 68" fill="none">
            <path d="M30.51 56.523C30.5041 56.6516 30.4488 56.7729 30.3557 56.8618C30.2625 56.9506 30.1387 57.0001 30.01 57C29.72 57 29.5 56.79 29.49 56.523C29.345 53.355 27.734 51.306 24.658 50.376C14.53 47.968 7 38.863 7 28C7 15.297 17.297 5 30 5C42.703 5 53 15.297 53 28C53 38.863 45.47 47.968 35.342 50.376C32.266 51.306 30.655 53.356 30.512 56.523H30.51Z" fill="currentColor"/>
            <path d="M30 68C27.79 68 26 66.21 26 64C26 61.79 27.79 60 30 60C32.21 60 34 61.79 34 64C34 66.21 32.21 68 30 68Z" fill="white"/>
            <path fill-rule="evenodd" clip-rule="evenodd" d="M30 66C30.2664 66.006 30.5312 65.9588 30.779 65.861C31.0269 65.7633 31.2527 65.617 31.4432 65.4308C31.6337 65.2446 31.7851 65.0222 31.8885 64.7766C31.9919 64.5311 32.0452 64.2674 32.0452 64.001C32.0453 63.7346 31.9921 63.4708 31.8889 63.2253C31.7856 62.9797 31.6343 62.7572 31.4439 62.5709C31.2535 62.3846 31.0277 62.2382 30.78 62.1403C30.5322 62.0425 30.2674 61.9951 30.001 62.001C29.4784 62.0125 28.9812 62.2282 28.6156 62.6018C28.2501 62.9754 28.0454 63.4773 28.0452 64C28.0451 64.5227 28.2496 65.0246 28.6149 65.3984C28.9803 65.7722 29.4775 65.9882 30 66Z" fill="currentColor"/>
            <path d="M35.8045 40H42.1775C42.7371 40 43.1808 39.822 43.5085 39.466C43.8362 39.11 44 38.6335 44 38.0366V24.2711C44 23.6742 43.8362 23.1977 43.5085 22.8417C43.1808 22.4857 42.7371 22.3077 42.1775 22.3077H36.3457V38.0366C36.3457 38.4034 36.2997 38.7504 36.2077 39.0776C36.1156 39.4049 35.9812 39.7123 35.8045 40ZM38.853 27.7664V26.0403C38.853 25.7886 38.9819 25.6628 39.2396 25.6628H41.073C41.3307 25.6628 41.4595 25.7886 41.4595 26.0403V27.7664C41.4595 28.0253 41.3307 28.1548 41.073 28.1548H39.2396C38.9819 28.1548 38.853 28.0253 38.853 27.7664ZM38.853 32.0169V30.2908C38.853 30.0391 38.9819 29.9132 39.2396 29.9132H41.073C41.3307 29.9132 41.4595 30.0391 41.4595 30.2908V32.0169C41.4595 32.2686 41.3307 32.3945 41.073 32.3945H39.2396C38.9819 32.3945 38.853 32.2686 38.853 32.0169ZM38.853 36.2674V34.5413C38.853 34.2824 38.9819 34.1529 39.2396 34.1529H41.073C41.3307 34.1529 41.4595 34.2824 41.4595 34.5413V36.2674C41.4595 36.5191 41.3307 36.6449 41.073 36.6449H39.2396C38.9819 36.6449 38.853 36.5191 38.853 36.2674ZM18 38.0366C18 38.6335 18.1638 39.11 18.4915 39.466C18.8192 39.822 19.2665 40 19.8335 40H32.9991C33.5661 40 34.0134 39.822 34.3411 39.466C34.6687 39.11 34.8326 38.6335 34.8326 38.0366V18.9634C34.8326 18.3593 34.6687 17.881 34.3411 17.5286C34.0134 17.1762 33.5661 17 32.9991 17H19.8335C19.2665 17 18.8192 17.1762 18.4915 17.5286C18.1638 17.881 18 18.3593 18 18.9634V38.0366ZM22.5947 38.2631V34.757C22.5947 34.5053 22.672 34.3057 22.8267 34.1583C22.9813 34.0109 23.1838 33.9372 23.4341 33.9372H29.4978C29.7555 33.9372 29.9599 34.0109 30.1108 34.1583C30.2618 34.3057 30.3373 34.5053 30.3373 34.757V38.2631H22.5947ZM22.2302 22.7931V20.7003C22.2302 20.391 22.3812 20.2364 22.6831 20.2364H24.8921C25.2087 20.2364 25.367 20.391 25.367 20.7003V22.7931C25.367 23.1024 25.2087 23.2571 24.8921 23.2571H22.6831C22.3812 23.2571 22.2302 23.1024 22.2302 22.7931ZM27.5649 22.7931V20.7003C27.5649 20.391 27.7196 20.2364 28.0288 20.2364H30.2268C30.5434 20.2364 30.7017 20.391 30.7017 20.7003V22.7931C30.7017 23.1024 30.5434 23.2571 30.2268 23.2571H28.0288C27.7196 23.2571 27.5649 23.1024 27.5649 22.7931ZM22.2302 27.1947V25.1018C22.2302 24.7925 22.3812 24.6379 22.6831 24.6379H24.8921C25.2087 24.6379 25.367 24.7925 25.367 25.1018V27.1947C25.367 27.5039 25.2087 27.6585 24.8921 27.6585H22.6831C22.3812 27.6585 22.2302 27.5039 22.2302 27.1947ZM27.5649 27.1947V25.1018C27.5649 24.7925 27.7196 24.6379 28.0288 24.6379H30.2268C30.5434 24.6379 30.7017 24.7925 30.7017 25.1018V27.1947C30.7017 27.5039 30.5434 27.6585 30.2268 27.6585H28.0288C27.7196 27.6585 27.5649 27.5039 27.5649 27.1947ZM22.2302 31.5962V29.5033C22.2302 29.194 22.3812 29.0394 22.6831 29.0394H24.8921C25.2087 29.0394 25.367 29.194 25.367 29.5033V31.5962C25.367 31.9054 25.2087 32.06 24.8921 32.06H22.6831C22.3812 32.06 22.2302 31.9054 22.2302 31.5962ZM27.5649 31.5962V29.5033C27.5649 29.194 27.7196 29.0394 28.0288 29.0394H30.2268C30.5434 29.0394 30.7017 29.194 30.7017 29.5033V31.5962C30.7017 31.9054 30.5434 32.06 30.2268 32.06H28.0288C27.7196 32.06 27.5649 31.9054 27.5649 31.5962Z" fill="white"/>
          </svg>
        </div>`
      )
    });
  }

  render() {
    const { children } = this.props;
    const { template } = this.state;

    return children({ template });
  }
}
const ConnectedTemplateProvider = withYMaps(TemplateProvider, true, ['templateLayoutFactory']);

const ContactsMap = () => {
  const [isLoading, setIsLoading] = useState(true);
  const [isError, setIsError] = useState(false);
  const [bounds, setBounds] = useState(null);
  const [points, setPoints] = useState(null);
  const [rawPoints, setRawPoints] = useState(null);
  const mapRef = useState(null);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axios.get(process.env.NEXT_PUBLIC_API + '/offices');

        if (!response.data || response.data.status !== 'ok') throw new Error(response.data.text);

        const points = [];
        const rawPoints = [];

        for (let i = 0; i < response.data.data.length; i += 1) {
          const group = response.data.data[i].offices;

          for (let j = 0; j < group.length; j += 1) {
            rawPoints.push({ address: group[j].address, point: group[j].point });
            points.push(group[j].point);
          }
        }

        setPoints(points);
        setRawPoints(rawPoints);
        setIsLoading(false);
        setIsError(false);
      } catch (error) {
        setIsLoading(false);
        setIsError(true);
      }
    };
    fetchData();
  }, []);
  useEffect(() => {
    if (mapRef.current) {
      mapRef.current.setBounds(bounds);
    }
  }, [mapRef]);

  if (isLoading || isError) {
    return (
      <section className={['block', styles.map].join(' ')}>
        <div className={styles.mapContainer}>
          <Skelet height="100%" style={{ borderRadius: 0 }} />
        </div>
      </section>
    );
  }

  return (
    <section className={['block', styles.map].join(' ')}>
      <div className={styles.mapContainer}>
        <YMaps query={{ apikey: process.env.NEXT_PUBLIC_YANDEX_KEY }}>
          <ConnectedTemplateProvider>
            {({ template }) => (
              <Map
                modules={['util.bounds', 'geoObject.addon.hint']}
                className={styles.container}
                defaultState={{
                  center: [47.233172, 39.717667],
                  zoom: 17,
                  controls: [],
                  behaviors: [!isMobile && 'drag', 'dblClickZoom', 'multiTouch']
                }}
                defaultOptions={{
                  maxZoom: 20,
                  autoFitToViewport: 'always',
                  yandexMapDisablePoiInteractivity: true,
                  suppressObsoleteBrowserNotifier: true,
                  suppressMapOpenBlock: true
                }}
                onLoad={(ymaps) => setBounds(ymaps.util.bounds.fromPoints(points))}
                instanceRef={(ref) => {
                  if (ref) {
                    mapRef.current = ref;
                  }
                }}
              >
                {!isMobile && (
                  <ZoomControl
                    options={{
                      position: { right: '12px', top: '178px' },
                      size: 'small'
                    }}
                  />
                )}
                <FullscreenControl
                  options={{
                    position: { right: '12px', top: '12px' }
                  }}
                />
                <GeolocationControl
                  options={{
                    position: { left: '12px', top: '12px' }
                  }}
                />
                {rawPoints.map((value, index) => (
                  <Placemark
                    properties={{
                      hintContent: value.address
                    }}
                    options={{
                      iconLayout: template,
                      iconOffset: [0, -65],
                      iconShape: {
                        type: 'Rectangle',
                        coordinates: [
                          [-25, 5],
                          [22, 68]
                        ]
                      }
                    }}
                    onClick={() => {
                      mapRef.current.panTo(value.point).then(() => {
                        mapRef.current.setZoom(16, { duration: 300 });
                      });
                    }}
                    geometry={value.point}
                    key={index}
                  />
                ))}
              </Map>
            )}
          </ConnectedTemplateProvider>
        </YMaps>
      </div>
    </section>
  );
};

export default ContactsMap;
